// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

export interface User{
  dni:string;
  email:string;
  id:string;
  name:string;
  parking_id:string;
  permisos:string;
  sala_id:string;
}

export interface ZkUser{
  id: string;
  created_at: string;
  dni: string;
  parkings : '';
  search: '';
  name: string;
}

export interface ZkDevice{
  id: string;
  name: string;
  priority: string;
}

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
